import { useEffect } from "react";
import tracking from "frontend/tracking";
import { useDebounce } from "./debounce";

const DEBOUNCE_TIMEOUT = 1000;
const SEACH_TERM_MIN_LENGTH = 2;

export default function useTrackSearch(
  searchTerm: string,
  eventName: string,
  eventProperties?: Record<string, unknown>
) {
  const debouncedSearchTerm = useDebounce(searchTerm, DEBOUNCE_TIMEOUT);

  useEffect(() => {
    if (debouncedSearchTerm.length > SEACH_TERM_MIN_LENGTH) {
      tracking.trackAnalyticsEvent(eventName, eventProperties);
    }
  }, [debouncedSearchTerm, eventName, eventProperties]);
}
